import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import styled from 'styled-components';

const StyledButton = styled.button`
  width: 305rem;
  height: 75px;
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: white;
  color: #ffb615;
  font-weight: bold;
  border-radius: 5px;
  border: 2px solid #ffb615;
`;

export default function FormDialog() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <StyledButton onClick={handleClickOpen}>
        {/* <button> */}
        <text color="primary">Compartilhar</text>
        <i className="fas fa-share-alt" />
        {/* </button> */}
      </StyledButton>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Compartilhar</DialogTitle>
        <DialogContent>
          <div style={{ alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
            <a href="https://instagram.com" style={{ padding: '10px' }}>
              {' '}
              <i className="fab fa-instagram" />{' '}
            </a>
            <a href="https://facebook.com" style={{ padding: '10px' }}>
              {' '}
              <i className="fab fa-facebook" />{' '}
            </a>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
